import { CommentsSection } from './comments-section';

export interface CommentsQuestionPage {
  pageNumberOffset: number;
  pageNumber: number;
  pageBlurb: string;
  sections: CommentsSection[];
}
